import { render, staticRenderFns } from "./talents_details.vue?vue&type=template&id=6b27d072&scoped=true"
import script from "./talents_details.vue?vue&type=script&lang=js"
export * from "./talents_details.vue?vue&type=script&lang=js"
import style0 from "./talents_details.vue?vue&type=style&index=0&id=6b27d072&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b27d072",
  null
  
)

export default component.exports